/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioEstadosDetallesCV from './controladorVista/formularioEstadosDetallesCV';
import TablaEstadosDetallesCV from './controladorVista/tablaEstadosDetallesCV';
import { estadoIncial, reductor } from './reductorEstadosDetalles';

const EstadosDetalles: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaEstadosDetallesCV />
        <FormularioEstadosDetallesCV />
    </ProveedorEstado>
);

export default EstadosDetalles;
